import { useRef, useState, forwardRef, useEffect } from "react"
import RcmpArrowRightSingleAccordion from "../../../assets/icons/ArrowRightSingleAccordion"

import styles from "./index.module.scss"

const MainTable = forwardRef((props, ref) => {
  const { children, bUpadateArrow, bHideArrow, scale, ...rest } = props

  const [bLeftArrow, fnSetBLeftArrow] = useState(false)
  const [bRightArrow, fnSetBRightArrow] = useState(false)

  const elTableContainerRef = useRef(null)
  const elTableRef = useRef(null)
  const intervalRef = useRef(null)

  function fnHandleStopHoverDirection() {
    clearInterval(intervalRef.current)
  }

  function fnHandleDirectionButtons() {
    if (!elTableContainerRef?.current) return
    const { clientWidth, scrollLeft } = elTableContainerRef.current

    const nScrollXPosition = clientWidth + scrollLeft

    if (scrollLeft <= 0) {
      fnSetBLeftArrow(false)
      fnHandleStopHoverDirection()
    } else {
      fnSetBLeftArrow(true)
    }

    if (nScrollXPosition >= elTableRef.current.offsetWidth) {
      fnSetBRightArrow(false)
      fnHandleStopHoverDirection()
    } else {
      fnSetBRightArrow(true)
    }
  }

  useEffect(() => {
    fnHandleDirectionButtons()
    window.addEventListener("resize", fnHandleDirectionButtons)

    return () => {
      window.removeEventListener("resize", fnHandleDirectionButtons)
    }
  }, [])

  useEffect(() => {
    fnHandleDirectionButtons()
  }, [children])

  useEffect(() => {
    if (bHideArrow) return

    fnHandleDirectionButtons()
  }, [bUpadateArrow])

  function fnHandleScroll(cDirection) {
    let nScrollLeft = elTableContainerRef.current?.scrollLeft

    if (cDirection === "right") {
      elTableContainerRef?.current?.scrollTo({
        left: (nScrollLeft += 550),
        behavior: "smooth",
      })
      return
    }

    if (cDirection === "left") {
      elTableContainerRef?.current?.scrollTo({
        left: (nScrollLeft -= 550),
        behavior: "smooth",
      })
      return
    }
  }

  function fnHandleScrollHover(cDirection) {
    intervalRef.current = setInterval(() => {
      fnHandleScroll(cDirection)
    }, 500)
  }

  function fnHandleOnScroll() {
    fnHandleDirectionButtons()
  }

  function fnHandleOnClick(cDirection) {
    fnHandleStopHoverDirection()
    fnHandleScroll(cDirection)
  }

  const oFullWidth = bHideArrow ? { width: "100%" } : {}

  return (
    <div className={styles.contentContainer} ref={ref}>
      {bRightArrow && (
        <div
          className={styles.arrowScroll}
          onClick={() => fnHandleOnClick("right")}
          onMouseOver={() => fnHandleScrollHover("right")}
          onMouseOut={fnHandleStopHoverDirection}
          style={{ height: scale }}
        >
          <RcmpArrowRightSingleAccordion fill={"#6CB6E3"} />
        </div>
      )}
      {bLeftArrow && (
        <div
          className={styles.arrowScrollL}
          onClick={() => fnHandleOnClick("left")}
          onMouseOver={() => fnHandleScrollHover("left")}
          onMouseOut={fnHandleStopHoverDirection}
          style={{ height: scale }}
        >
          <RcmpArrowRightSingleAccordion fill={"#6CB6E3"} />
        </div>
      )}
      <div
        className={styles.tableContainer}
        ref={elTableContainerRef}
        id={"scrollScreem"}
        onScroll={fnHandleOnScroll}
      >
        <table
          className={styles.table}
          style={oFullWidth}
          {...rest}
          ref={elTableRef}
          id={"tableScreen"}
        >
          {children}
        </table>
      </div>
    </div>
  )
})
MainTable.displayName = "Table"

const THead = forwardRef((props, ref) => {
  const { children, ...rest } = props

  return (
    <thead id="tableHead" ref={ref} {...rest} className={styles.THead}>
      {children}
    </thead>
  )
})

THead.displayName = "Table.Head"

const TBody = forwardRef((props, ref) => {
  const { children, ...rest } = props

  return (
    <tbody id={"tableBody"} ref={ref} {...rest}>
      {children}
    </tbody>
  )
})

TBody.displayName = "Table.Body"

const TRow = forwardRef((props, ref) => {
  const { children, ...rest } = props
  return (
    <tr ref={ref} className={styles.TRow} {...rest}>
      {children}
    </tr>
  )
})

TRow.displayName = "Table.Row"

function TData(props) {
  const { children, className, ...rest } = props
  const classes = ` ${className} ${styles.TData}`
  return (
    <td className={classes} {...rest}>
      {children}
    </td>
  )
}

TData.displayName = "Table.Data"

const HeadData = forwardRef((props, ref) => {
  const { children, isDragging, ...oRest } = props
  return (
    <th ref={ref} {...oRest}>
      {children}
    </th>
  )
})

HeadData.displayName = "Table.HeadData"

const Table = Object.assign(MainTable, { THead, TBody, TRow, TData, HeadData })

export default Table
